export default __webpack_public_path__ + "static/media/Whiteboard_128x128.d6fbc180.webp";